<template>
	<v-menu
		:model-value="absenceMenuStore.contextMenu.isOpen"
		@update:model-value="(val) => !val && absenceMenuStore.closeContextMenu()"
		:target="[absenceMenuStore.contextMenu.x, absenceMenuStore.contextMenu.y]"
		:close-on-content-click="false"
		location="bottom start"
	>
		<v-list density="compact" min-width="180" class="context-menu-list">
			<v-menu v-if="absenceMenuStore.absenceList.items.length > 0" :close-on-content-click="false" open-on-hover submenu location="end top">
				<template #activator="{ props: activatorProps }">
					<v-list-item v-bind="activatorProps" :prepend-icon="'mdi-pencil'">
						<v-list-item-title>{{ t('absence.title.with_count', { count: absenceMenuStore.absenceList.items.length }) }}</v-list-item-title>
						<template #append>
							<v-icon size="16">mdi-chevron-right</v-icon>
						</template>
					</v-list-item>
				</template>
				<PlanningAbsenceSubmenu />
			</v-menu>

			<v-tooltip v-if="absenceMenuStore.isCellLocked" location="top" open-delay="300">
				<template #activator="{ props: tooltipProps }">
					<span v-bind="tooltipProps">
						<v-list-item disabled>
							<template #prepend>
								<v-icon size="18">mdi-plus</v-icon>
							</template>
							<v-list-item-title>{{ t('absence.action.create') }}</v-list-item-title>
						</v-list-item>
					</span>
				</template>
				{{ t('absence.create_locked_message') }}
			</v-tooltip>

			<v-list-item v-else @click="handleCreateAbsence">
				<template #prepend>
					<v-icon size="18">mdi-plus</v-icon>
				</template>
				<v-list-item-title>{{ t('absence.action.create') }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script setup lang="ts">
import { usePlanningAbsenceMenuStore } from '@/rennovation/planning-view/store/usePlanningAbsenceMenuStore';
import PlanningAbsenceSubmenu from '@/rennovation/planning-view/components/Layout/Modals/PlanningAbsenceSubMenu.vue';
import { useI18n } from 'vue-i18n';

const absenceMenuStore = usePlanningAbsenceMenuStore();
const { t } = useI18n();

const handleCreateAbsence = () => {
	absenceMenuStore.openCreateModal();
	absenceMenuStore.closeContextMenu();
};
</script>

<style scoped>
:deep(.v-list-item__prepend) {
	width: 24px !important;
	min-width: 24px !important;
	margin-inline-end: 0 !important;
}

:deep(.v-list-item__prepend > .v-icon) {
	font-size: 16px !important;
	margin-inline-end: 0 !important;
}
</style>
